<div class="modal-header"><h2 class="modal-title">Email Message</h2></div>
<div class="modal-body" (keyup.esc)="cancel()">
  @if (emailMessage) {
    <dx-form [formData]="emailMessage" validationGroup="emailDialogValidationGroup">
      @if (mode === 'Customer') {
        @if(emailMessage.to !== null) {
          <dxi-item dataField="to" [editorOptions]="{ disabled: true }"> </dxi-item>
        } @else {
          <dxi-item [label]="{ text: 'To' }">
            <div *dxTemplate>
              <dx-text-box [value]="multipleEmails" [disabled]="true"  ></dx-text-box>
            </div>
          </dxi-item>

        }
        } @if(mode !== 'Customer') {
        <dxi-item dataField="to" [isRequired]="true"> </dxi-item>
      }
      <dxi-item dataField="subject"> </dxi-item>
      <dxi-item dataField="body" editorType="dxTextArea" [editorOptions]="{ height: 250 }"> </dxi-item>

      @if(mode !== 'Customer') {
        <dxi-item [label]="{ text: 'Report' }">
          <div *dxTemplate>
            <a [routerLink]="" (click)="openReport()">View Report</a>
          </div>
        </dxi-item>
      }
      <dxi-item [label]="{ text: 'Attachments' }">
        <div *dxTemplate>
          <dx-file-uploader
            name="fileUpload"
            selectButtonText="Select File(s)"
            class="attachments"
            accept="*"
            uploadMode="instantly"
            [showFileList]="false"
            [multiple]="true"
            [uploadUrl]="uploadUrl"
            [uploadHeaders]="uploadHeader"
            (onUploadStarted)="uploadStarted($event)"
            (onUploadError)="uploadError($event)"
            (onUploaded)="uploaded($event)"
            >
          </dx-file-uploader>
          <ul style="list-style-type: none; padding-inline-start: 0px">
            @for (attachment of attachments; track attachment) {
              <li>
                <a title="remove" (click)="removeAttachment(attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>
                <a title="view" class="ms-1" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
              </li>
            }
          </ul>
        </div>
      </dxi-item>
    </dx-form>
  }
</div>

<div class="modal-footer">
  <button class="btn btn-success" [disabled]="processing" (click)="save()">Send</button>
  <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
</div>
